import BaseMap from '../enums/BaseMapTypes';
import Mixpanel, { MAP_LAYER_ACTION, MIXPANEL_EVENTS } from './Mixpanel';

const isLegendLayer = group => group.id !== BaseMap.STREET;
const isShown = group => group.layers.some(layer => layer.visible);

export const visibilityAction = visible =>
    visible ? MAP_LAYER_ACTION.SHOW : MAP_LAYER_ACTION.HIDE;

export function trackLayerChange(viewCode, action, group, sublayer) {
    if (!isLegendLayer(group)) return;
    Mixpanel.emitUserEvent(MIXPANEL_EVENTS.CHANGE_MAP_LAYER, {
        viewCode,
        action,
        layerId: group.id,
        layerName: group.metadata.title,
        ...(sublayer && { sublayerId: sublayer.id, sublayerName: sublayer.title }),
    });
}

export function trackLayersOnLoad(viewCode, groups, definitions) {
    const titles = new Map(
        definitions.map(definition => [definition.id, definition.metadata.title]),
    );
    const layers = groups.filter(group => isLegendLayer(group) && titles.has(group.id));
    const shown = layers.filter(isShown);
    const hidden = layers.filter(group => !isShown(group));
    Mixpanel.emitUserEvent(MIXPANEL_EVENTS.VIEW_MAP_LAYERS, {
        viewCode,
        shownLayerIds: shown.map(group => group.id),
        shownLayerNames: shown.map(group => titles.get(group.id)),
        hiddenLayerIds: hidden.map(group => group.id),
        hiddenLayerNames: hidden.map(group => titles.get(group.id)),
    });
}
